export const ru = {

  translations: {


  }
}

